import { Link } from 'react-router-dom';
import { Button } from '../../components/shared/Button';
import { ProductCard } from '../../components/public/ProductCard';
import { Spinner } from '../../components/shared/Spinner';
import { UserIcon, WhatsAppIcon, PackageIcon } from '../../components/shared/icons';
import { useProductos } from '../../hooks/useProductos';
import { useCategorias } from '../../hooks/useCategorias';
import imagenHero from '../../assets/hero-artesania-peruana.jpg';

export function HomePage() {
  const { data: productos, isLoading } = useProductos();
  const { data: categorias } = useCategorias();
  const destacados = (productos ?? []).slice(0, 4);
  const categoriasDestacadas = (categorias ?? []).slice(0, 6);

  return (
    <>
      <section className="bg-gradient-to-br from-[oklch(94%_0.03_70)] to-bg py-10 md:py-16">
        <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-14 px-4 sm:px-6 md:px-14">
          <div className="flex-1 flex flex-col gap-5 text-center md:text-left items-center md:items-start">
            <div className="text-[13px] font-bold uppercase tracking-widest text-terracotta">
              Artesanía religiosa peruana
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-semibold leading-tight text-[oklch(28%_0.03_50)]">
              Fe hecha a mano,
              <br />
              con devoción
            </h1>
            <p className="text-[15px] md:text-[17px] leading-relaxed text-ink-muted max-w-md">
              Rosarios, estampas, velas y cruces trabajados por artesanos peruanos. Piezas para tu
              altar, tu regalo o tu negocio — con precios especiales por docena.
            </p>
            <div className="flex flex-wrap justify-center md:justify-start gap-3.5 mt-2">
              <Link to="/catalogo">
                <Button>Ver catálogo</Button>
              </Link>
              <Link to="/sobre-nosotros">
                <Button variante="outline">Sobre nosotros</Button>
              </Link>
            </div>
          </div>
          <div className="flex-1 flex items-center justify-center">
            <img
              src={imagenHero}
              alt="Rosarios y dijes de artesanía religiosa peruana en exhibición"
              className="w-48 h-48 sm:w-64 sm:h-64 md:w-80 md:h-80 rounded-xl object-cover shadow-2xl"
            />
          </div>
        </div>
      </section>

      {categoriasDestacadas.length > 0 && (
        <section className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-14 py-10 md:py-14 flex flex-col gap-7">
          <h2 className="text-2xl font-display font-semibold text-[oklch(28%_0.03_50)]">
            Explora por categoría
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
            {categoriasDestacadas.map((cat) => (
              <Link
                key={cat.id}
                to={`/catalogo?categoriaId=${cat.id}`}
                className="flex flex-col items-center gap-2.5 py-6 px-3 bg-surface border border-border rounded-xl hover:border-terracotta"
              >
                <PackageIcon width={24} height={24} className="text-terracotta shrink-0" />
                <span className="text-[13px] font-semibold text-center">{cat.nombre}</span>
              </Link>
            ))}
          </div>
        </section>
      )}

      <section className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-14 pb-10 md:pb-14 flex flex-col gap-6">
        <div className="flex flex-col sm:flex-row sm:items-baseline justify-between gap-2">
          <h2 className="text-2xl font-display font-semibold text-[oklch(28%_0.03_50)]">
            Los más pedidos
          </h2>
          <Link to="/catalogo" className="text-sm font-semibold">
            Ver todo el catálogo →
          </Link>
        </div>
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {destacados.map((p) => (
              <ProductCard key={p.id} producto={p} />
            ))}
          </div>
        )}
      </section>

      <section className="bg-[oklch(94%_0.02_70)] border-y border-border py-9">
        <div className="max-w-[1280px] mx-auto flex flex-wrap justify-center gap-6 md:gap-16 px-4 sm:px-6 md:px-14">
          <div className="flex items-center gap-2.5 text-sm font-semibold text-wood">
            <UserIcon width={18} height={18} className="text-terracotta shrink-0" />
            Trabajo artesanal peruano
          </div>
          <div className="flex items-center gap-2.5 text-sm font-semibold text-wood">
            <WhatsAppIcon width={18} height={18} className="text-terracotta shrink-0" />
            Coordina tu pedido por WhatsApp
          </div>
          <div className="flex items-center gap-2.5 text-sm font-semibold text-wood">
            <PackageIcon width={18} height={18} className="text-terracotta shrink-0" />
            Precios especiales por docena
          </div>
        </div>
      </section>
    </>
  );
}
